// new js

$(document).ready(function () {
    $('.engraving-fonts input[type="radio"]').on("change", function (e) {
        if ($(this).prop("checked") == true) {
            var fontName = $.trim($(this).val());
            if (
                typeof fontName != "undefined" &&
                fontName != null &&
                fontName != ""
            ) {
                if ($("#product-properties-name").length > 0) {
                    $("#product-properties-name").css("font-family", fontName);
                    $("#product-properties-name").css("letter-spacing", "4px");
                    $("#product-properties-name").css("font-size", "20px");
                }
                if ($("#product-properties-number").length > 0) {
                    $("#product-properties-number").css("font-family", fontName);
                    $("#product-properties-number").css("letter-spacing", "2px");
                    $("#product-properties-number").css("font-size", "20px");
                }
            }
        }
    });

    $('.engraving-fonts input[type="radio"]').on("click", function (e) {
        if ($(this).hasClass("already-checked")) {
            $(this).prop("checked", true);
        } else {
            $('.engraving-fonts input[type="radio"]').removeClass("already-checked");
            $(this).addClass("already-checked");
        }
    });

    // ADD TO CART

    // $(".custom-add-to-cart-button").on("click", function(e) {
    //   setTimeout(function(){
    //        e.preventDefault();
    //         var checkEngravingValue = true;
    //        var checkEngravinge = false;
    //        if ($('.engraving-fonts input[type="radio"]').length > 0) {
    //            // checkEngravingValue = false;
    //            $('.engraving-fonts input[type="radio"]').each(function(e) {
    //                if ($(this).prop("checked") == true) {
    //                     checkEngravingValue = true;
    //                    checkEngravinge = true;
    //                }
    //            });
    //        }
    //        if (checkEngravingValue) {
    //            if (checkEngravinge) {
    //                console.log(checkEngravinge);
    //                 var variantId = 43315726647513;
    //                $.ajax({
    //                    type: 'POST',
    //                    url: '/cart/add.js',
    //                    data: {
    //                        quantity: 1,
    //                        id: variantId
    //                    },
    //                    dataType: 'json',
    //                    success: function(data) {
    //                        console.log('succccccc 1');
    //                    }
    //                });
    //                // Paid Engraving End
    //            }
    //            // $(this).parents("form.product-form").submit();
    //            $('.add_to_cart_wrapper').removeClass('custom--engrave-added');
    //            $('.engraving--added').delay(1000).fadeOut();
    //            $('.Engrave--btn').delay(1500).fadeIn();
    //            $('.radio__selection--btn input[type="radio"]').prop('checked', false);
    //            $("#product-properties-name").val('');
    //            $("#product-properties-number").val('');
    //        } else {
    //            nameValue = $.trim($("#product-properties-name").val());
    //            numberValue = $.trim($("#product-properties-number").val());
    //            if ((typeof nameValue != "undefined" && nameValue != null && nameValue != "") || (typeof numberValue != "undefined" && numberValue != null && numberValue != "")) {
    //                $.fancybox.open({
    //                    src: '#engraving_popup_wrapper',
    //                    type: 'inline',
    //                    opts: {
    //                        afterShow: function(instance, current) {

    //                        },
    //                        touch: false,
    //                        clickSlide: false,
    //                        clickOutside: false,
    //                        baseClass: 'engraving_fancybox_wrapper',
    //                    }
    //                });
    //            } else {
    //                if (checkEngravinge) {
    //                    console.log(checkEngravingValue);

    //                     var variantId = 43315726647513;

    //                    $.ajax({
    //                        type: 'POST',
    //                        url: '/cart/add.js',
    //                        data: {
    //                            quantity: 1,
    //                            id: variantId
    //                        },
    //                        dataType: 'json',
    //                        success: function(data) {
    //                            console.log('succccccc 2');
    //                        }
    //                    });
    //                    // Paid Engraving End
    //                }
    //                // $(this).parents("form.product-form").submit();
    //            }
    //        }
    //      },600)
    //    });

    // END

    $(".on-key-up-js").on("keydown keyup change", function (e) {
        var value = $(this).val();
        if (value.length > 11 && e.keyCode !== 46 && e.keyCode !== 8) {
            $(this).next(".ch__counter").html("");
            $(this)
                .next(".ch__counter")
                .html(value.length + "/12");
            e.preventDefault();
        } else {
            $(this).next(".Error").hide();
            $(this).next(".ch__counter").html("");
            $(this)
                .next(".ch__counter")
                .html(value.length + "/12");
        }
    });
    $("input[type='number'].on-key-up-js").on("input", function (e) {
        $(this).val(
            $(this)
                .val()
                .replace(/[^0-9]/g, "")
        );
    });
    $(".on-key-up-js.line1").on("keydown keyup change", function (e) {
        var value = $(this).val();
        if (value.length > 9 && e.keyCode !== 46 && e.keyCode !== 8) {
            $(this).next(".ch__counter").html("");
            $(this)
                .next(".ch__counter")
                .html(value.length + "/9");
            e.preventDefault();
        } else {
            $(this).next(".Error").hide();
            $(this).next(".ch__counter").html("");
            $(this)
                .next(".ch__counter")
                .html(value.length + "/9");
        }
    });

    // $(".coll-meta").each(function () {
    //   var per = $(this)
    //     .children(".content_div")
    //     .children(".product_data")
    //     .find("p.field_price")
    //     .attr("attr_pre");
    //   if (per == 0) {
    //     $(this).addClass("show_per");
    //   } else {
    //     $(this).removeClass("show_per");
    //   }
    // });
});

$(document).ready(function () {
    $(".Engrave--btn").click(function () {
        $(".engraving-slide-drawer").addClass("open__engraving");
    });
    const product__contentWraperOffset = $(".product__content--wrapper").offset()
    $("#engraving-cancel-btn").click(function () {
        $(".engraving-slide-drawer").removeClass("open__engraving");
        let offset = $(".product__content--wrapper").offset()
        if (product__contentWraperOffset != undefined){
            $("html,body").animate({
                scrollTop: product__contentWraperOffset.top,
            });
        }
    });
    $("#close-engraving-slide").click(function () {
        $(".engraving-slide-drawer").removeClass("open__engraving");
        console.log("dsssf");
        if (product__contentWraperOffset != undefined){
            $("html,body").animate({
                scrollTop: product__contentWraperOffset.top,
            });
        }

        //            $('body').removeClass("fixed-position");
    });
    $("#engraving-submit-btn").click(function () {
        var error = "This feild is required";
        let r1;
        let r2;
        let r3;
        var input1 = false;
        var input2 = false;
        var input3 = false;
        r1 = $('.engraving-fonts input[type="radio"]:checked').val();
        if (r1 === undefined || r1 === null || r1 === "") {
            console.log("engraving font is missing");
            $.fancybox.open({
                src: "#custom_engraving_popup_wrapper_font",
                type: "inline",
                opts: {
                    afterShow: function (instance, current) { },
                    touch: false,
                    clickSlide: false,
                    clickOutside: false,
                    baseClass: "engraving_fancybox_wrapper",
                },
            });
        } else {
            var input1 = true;
            $("#fontName").text("Font: " + r1);
        }
        r2 = $("#product-properties-name").val();
        if (r2 === undefined || r2 === null || r2 === "") {
            // $("#Name").hide();
            console.log("engraving name is missing");
            $.fancybox.open({
                src: "#custom_engraving_popup_wrapper_name",
                type: "inline",
                opts: {
                    afterShow: function (instance, current) { },
                    touch: false,
                    clickSlide: false,
                    clickOutside: false,
                    baseClass: "engraving_fancybox_wrapper",
                },
            });
        } else {
            var input2 = true;
            $("#Name").text("Name: " + r2);
        }
        r3 = $("#product-properties-number").val();
        if (r3 === undefined || r3 === null || r3 === "") $("#phone").hide();
        else {
            var input3 = true;
            $("#phone").text("phone Number: " + r3);
        }
        if (input1 && input2) {
            $(".engraving-slide-drawer").removeClass("open__engraving");
            //                $('body').removeClass("fixed-position");
            $(".Engrave--btn").hide();
            $(".add_to_cart_wrapper").addClass("custom--engrave-added");
            $(".engraving--added").show();
            if (product__contentWraperOffset != undefined){
              $("html,body").animate({
                  scrollTop: product__contentWraperOffset.top,
              });
            }
        } else {
            console.log("pls fill first");
        }
    });
    $("#product-properties-name").on("keydown keyup change", function (e) {
        $("#nameError").hide();
    });
    $("#product-properties-number").on("keydown keyup change", function (e) {
        $("#phoneError").hide();
    });
    $('.radio__selection--btn input[type="radio"]').change(function () {
        $("#fontError").hide();
    });

    $(".engrave--edit").click(function () {
        if ($(window).width() < 767) {
            // $(".engraving-slide-drawer").addClass("open__engraving");
        } else {
            // $("#engraving-popup").addClass("active");
        }
        //               $('body').addClass("fixed-position");
    });
    $(".engrave--remove").click(function () {
        $('.radio__selection--btn input[type="radio"]').prop("checked", false);
        $("#product-properties-name").val("");
        $("#product-properties-number").val("");
        $(".engraving--added").hide();
        $(".Engrave--btn").show();
        $(".desktop-engrave-bttn").show();
        $(".add_to_cart_wrapper").removeClass("custom--engrave-added");
    });
});

$(document).ready(function () {
    $(".faq__accordion .faq__toggle").click(function (e) {
        e.preventDefault();

        let $this = $(this);

        if ($this.next().hasClass("show_block")) {
            $this.next().removeClass("show_block");
            $this.next().slideUp(350);
        } else {
            $this.parent().parent().find("li .faq__inner").removeClass("show_block");
            $this.parent().parent().find("li .faq__inner").slideUp(350);
            $this.next().toggleClass("show_block");
            $this.next().slideToggle(350);
        }
    });
});

// /Dynamic Engraving
$(document).ready(function () {
    var imageLoader = document.getElementById("imageLoader");
    var canvas = document.getElementById("imageCanvas");
    if (!canvas) {
        return;
    }
    var ctx = canvas.getContext("2d");
    var img = new Image();
    img.crossOrigin = "anonymous";

    window.addEventListener("load", DrawPlaceholder);

    function DrawPlaceholder() {
        img.onload = function () {
            DrawOverlay(img);
        };
        img.src =
            "https://cdn.shopify.com/s/files/1/0102/1437/5505/files/Engraving-collar-desktop.png?v=1670487212";
    }

    function DrawOverlay(img) {
        ctx.drawImage(img, 0, 0);
        ctx.fillStyle = "rgba(30, 144, 255, 0.0)";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
    }

    function convertToImage() {
        window.open(canvas.toDataURL("png"));
    }

    $(".free__engraving__wrapper").click(function () {
        $("#engraving-popup").find('input').val('').trigger('keyup').trigger('change');
        $("#engraving-popup").addClass("active");
    });
    $(".custom-engraving-popup__close").click(function () {
        $("#engraving-popup").removeClass("active");
    });
    $(".engraving-popup input[type=radio]").change(function () {
        let inputId = $(this).attr("id");
        console.log(inputId);
        let fontName = $.trim($(this).val());
        let imageSrc = $(this).parent().find("img").attr("src");

        switch (inputId) {
            case "select_font_1":
                $("#font_1").prop("checked", true);
                if (
                    typeof fontName != "undefined" &&
                    fontName != null &&
                    fontName != ""
                ) {
                    if ($(".textline1").length > 0) {
                        $(".textline1").css("font-family", fontName);
                        $(".textline1").css("letter-spacing", "2px");
                        $(".textline1").css("font-size", "15px");
                        $(".textline1").css("font-weight", "bold");
                    }
                    if ($(".textline2").length > 0) {
                        $(".textline2").css("font-family", fontName);
                        $(".textline2").css("letter-spacing", "2px");
                        $(".textline2").css("font-size", "12px");
                        $(".textline2").css("font-weight", "bold");
                    }
                }
                break;
            case "select_font_2":
                $("#font_2").prop("checked", true);
                if (
                    typeof fontName != "undefined" &&
                    fontName != null &&
                    fontName != ""
                ) {
                    if ($(".textline1").length > 0) {
                        $(".textline1").css("font-family", fontName);
                        $(".textline1").css("letter-spacing", "2px");
                        $(".textline1").css("font-size", "20px");
                        $(".textline1").css("font-weight", "600");
                    }
                    if ($(".textline2").length > 0) {
                        $(".textline2").css("font-family", fontName);
                        $(".textline2").css("letter-spacing", "2px");
                        $(".textline2").css("font-size", "16px");
                        $(".textline2").css("font-weight", "600");
                    }
                }
                break;
            case "select_icon_1":
            case "icon_1":
                $("#icon_1").prop("checked", true);
                $(".line-one-image").attr("src", imageSrc);
                $(".line-one-image").removeClass("hide");
                break;
            case "select_icon_2":
            case "icon_2":
                $("#icon_2").prop("checked", true);
                $(".line-one-image").attr("src", imageSrc);
                $(".line-one-image").removeClass("hide");
                break;
            case "select_icon_3":
            case "icon_3":
                $("#icon_3").prop("checked", true);
                $(".line-one-image").attr("src", imageSrc);
                $(".line-one-image").removeClass("hide");
                break;
            case "select_icon_4":
            case "icon_4":
                $("#icon_4").prop("checked", true);
                $(".line-one-image").attr("src", imageSrc);
                $(".line-one-image").removeClass("hide");
                break;
            case "select_icon_5":
            case "icon_5":
                $("#icon_5").prop("checked", true);
                $(".line-one-image").attr("src", imageSrc);
                $(".line-one-image").removeClass("hide");
                break;

            default:
                console.log("nothing");
        }
    });

    $(
        ".radio__selection--btn.js-selection .radio_container input[type=radio]"
    ).change(function () {
        let inputId = $(this).attr("id");
        console.log(inputId);
        let fontName = $.trim($(this).val());
        let imageSrc = $(this).parent().find("img").attr("src");
        switch (inputId) {
            case "font_1":
                if (
                    typeof fontName != "undefined" &&
                    fontName != null &&
                    fontName != ""
                ) {
                    if ($(".textline1").length > 0) {
                        $(".textline1").css("font-family", fontName);
                        $(".textline1").css("letter-spacing", "2px");
                        $(".textline1").css("font-size", "15px");
                        $(".textline1").css("font-weight", "bold");
                        $("#line1").css("font-family", fontName);
                        $("#line1").css("letter-spacing", "2px");
                        $("#line1").css("font-size", "15px");
                    }
                    if ($(".textline2").length > 0) {
                        $(".textline2").css("font-family", fontName);
                        $(".textline2").css("letter-spacing", "2px");
                        $(".textline2").css("font-size", "14px");
                        $("#line2").css("font-family", fontName);
                        $("#line2").css("letter-spacing", "2px");
                        $("#line2").css("font-size", "14px");
                        $(".textline2").css("font-weight", "bold");
                    }
                }
                break;
            case "font_2":
                if (
                    typeof fontName != "undefined" &&
                    fontName != null &&
                    fontName != ""
                ) {
                    if ($(".textline1").length > 0) {
                        $(".textline1").css("font-family", fontName);
                        $(".textline1").css("letter-spacing", "2px");
                        $(".textline1").css("font-size", "15px");
                        $("#line1").css("font-family", fontName);
                        $("#line1").css("letter-spacing", "2px");
                        $("#line1").css("font-size", "15px");
                        $("#line1").css("font-weight", "600");
                    }
                    if ($(".textline2").length > 0) {
                        $(".textline2").css("font-family", fontName);
                        $(".textline2").css("letter-spacing", "2px");
                        $(".textline2").css("font-size", "14px");
                        $("#line2").css("font-family", fontName);
                        $("#line2").css("letter-spacing", "2px");
                        $("#line2").css("font-size", "14px");
                        $("#line2").css("font-weight", "600");
                    }
                }
                break;
            default:
                console.log("nothing");
        }
    });

    $("#line1").on("keyup change", function (e) {
        let text_title = $(this).val();
        $("#product-properties-name").val(text_title);
        $(".textline1").text(text_title);
    });
    $("#line2").on("keyup change", function (e) {
        let text_title = $(this).val();
        $("#product-properties-number").val(text_title);
        $(".textline2").text(text_title);
    });
    $("#product-properties-name").on("keyup change", function (e) {
        let text_title = $(this).val();
        $(".textline1").text(text_title);
    });
    $("#product-properties-number").on("keyup change", function (e) {
        let text_title = $(this).val();
        $(".textline2").text(text_title);
    });

    $("#engraving-popup-submit").click(function () {
        // let checkSelectedFont = $(
        //   ".radio__selection--btn.engraving-fonts .radio_container input[type=radio]:checked"
        // );
        // let checkSelectedName = $(
        //   ".radio__selection--btn.engraving-fonts .radio_container input[type=radio]:checked"
        // );
        let fontValue = $('.engraving-fonts input[type="radio"]:checked').val();
        let nameValue = $("#product-properties-name").val();
        let numberValue = $("#product-properties-number").val();
        if (!fontValue) {
            $.fancybox.open({
                src: "#engraving_popup_wrapper",
                type: "inline",
                opts: {
                    afterShow: function (instance, current) { },
                    touch: false,
                    clickSlide: false,
                    clickOutside: false,
                    baseClass: "engraving_fancybox_wrapper",
                },
            });
        } else if (!nameValue && !numberValue) {
            $.fancybox.open({
                src: "#custom_engraving_popup_wrapper_name",
                type: "inline",
                opts: {
                    afterShow: function (instance, current) { },
                    touch: false,
                    clickSlide: false,
                    clickOutside: false,
                    baseClass: "engraving_fancybox_wrapper",
                },
            });
        } else {
            $("#engraving-popup").removeClass("active");
            $("#fontName").text("Font: " + fontValue);

            if (!nameValue) {
                $("#Name").hide();
            } else {
                $("#Name").text("Name: " + nameValue);
            }
            if (!numberValue) {
                $("#phone").hide();
            }
            else {
                $("#phone").text("phone Number: " + numberValue);
            }
            if (fontValue && (nameValue || numberValue)) {
                $(".desktop-engrave-bttn").hide();
                $(".add_to_cart_wrapper").addClass("custom--engrave-added");
                $(".engraving--added").show();
                const product__contentWraperOffset = $(".product__content--wrapper").offset()
                if (product__contentWraperOffset != undefined){
                    $("html,body").animate({
                        scrollTop: product__contentWraperOffset.top,
                    });
                }
            } else {
                console.log("pls fill first");
            }
        }
    });
});

// end here

// $(document).ready(function () {
//   $(".coll-meta:first-child").addClass("bundle_active");
//   $(".data_p .var_text:nth-child(1)").toggleClass("price_active");
//   $(".coll-meta").each(function () {
//     if ($(this).hasClass("bundle_active")) {
//       var top_check = "no-custom";
//       var check = $(this).attr("temp-name");
//       if (top_check == check) {
//         $(".btn_main_de").hide();
//       } else {
//         $(".btn_main_de").show();
//       }
//     }
//   });
// });

// $(".content_div").click(function () {
//   $(this).parent(".coll-meta").addClass("bundle_active");
//   $(this).parent(".coll-meta").siblings().removeClass("bundle_active");
//   var title = $(this).parent(".coll-meta").attr("data-match");
//   $(".data_p").each(function (index) {
//     var title_2 = $(this).attr("data-title");
//     if (title == title_2) {
//       $(this).css("display", "flex");
//       $(this).addClass("show_color");
//     } else {
//       $(this).removeClass("show_color");
//     }
//   });
//   var top_check = "no-custom";
//   var check = $(this).parents(".coll-meta").attr("temp-name");
//   if (top_check == check) {
//     $(".btn_main_de").hide();
//   } else {
//     $(".btn_main_de").show();
//   }

//   var cont_text = $(this).children(".product_data").find(".field_title").text();
//   var matc = $(".custom_btn").attr("attr_mtc");
//   if (cont_text == matc) {
//     $(".custom_btn").hide();
//   } else {
//     $(".custom_btn").show();
//   }
// });

// $(".var_text").click(function () {
//   $(this).parent(".data_p").removeClass("show_color");
//   $(this).addClass("price_active");
//   $(this).siblings().removeClass("price_active");
//   var $this = $(this);
//   $('.var_text[size="' + $this.text() + '"]').each(function () {
//     var vid_price = $(
//       '.coll-meta[pro_id="' + $(this).attr("pro_id_1") + '"] .field_price '
//     ).html($(this).attr("attr-price"));
//     $('.coll-meta[pro_id="' + $(this).attr("pro_id_1") + '"] p.cm_price').html(
//       $(this).attr("attr_com")
//     );
//     $(
//       '.coll-meta[pro_id="' + $(this).attr("pro_id_1") + '"] p.save_price'
//     ).html($(this).attr("attr_save"));
//     var title = $(this).attr("proti");
//     var mat = $(".coll-meta.bundle_active").attr("data-match");
//     if (title == mat) {
//       var qut = $(this).attr("quantitiy");
//       var qut1 = $(this).attr("quantitiy1");
//       console.log(qut);
//       if (qut1 < 1) {
//         $(".sold-meta").addClass("sold_show");
//         $(".add-products").attr("disabled", true);
//         $(".mobile_add").attr("disabled", true);
//         $(".add-products").addClass("sold_btn");
//         $(".mobile_add").addClass("sold_btn");
//       } else if (qut < 1) {
//         $(".sold-meta").removeClass("sold_show");
//         $(".add-products").attr("disabled", false);
//         $(".mobile_add").attr("disabled", false);
//         $(".add-products").removeClass("sold_btn");
//         $(".mobile_add").removeClass("sold_btn");
//       }
//     }
//   });
// });

// $(".row_meta .coll-meta").click(function () {
//   const sym = (currency, locale) =>
//     new Intl.NumberFormat(locale, { style: "currency", currency })
//       .formatToParts(1)
//       .find((x) => x.type === "currency").value;
//   var match_point = $(this).attr("data-match");
//   var active = $(".var_text.price_active").text();
//   var vid_price_se = $(
//     '.var_text[proti="' + match_point + '"][size="' + active + '"]'
//   ).attr("attr-price");
//   var price_main = $(".coll-meta.bundle_active")
//     .children(".content_div")
//     .find(".product_data")
//     .children(".field_price")
//     .text(sym(Shopify.currency.active) + (vid_price_se / 100).toFixed(2));
// });

// $('.coll-meta[data-match="Bundle"]').click(function () {
//   $(".new_collar").hide();
// });
// $('.coll-meta[data-match="Bowtie Collar & Leash Set"]').click(function () {
//   $(".new_collar").show();
// });
// $('.coll-meta[data-match="Mega Bundle"]').click(function () {
//   $(".new_collar").show();
// });

// $(".coll-meta").click(function () {
//   var coll_nnn = $(this).attr("data-match");
//   var part_nn = $(".col-btn-div .new_collar").attr("attr_na");
//   if (coll_nnn == part_nn) {
//     $(".col-btn-div .new_collar").hide();
//   } else {
//     $(".col-btn-div .new_collar").show();
//   }

//   var call_sw = $(".data_p .var_text.price_active").text();
//   $('.var_text[size="' + call_sw + '"]').each(function () {
//     var prop = $(".coll-meta.bundle_active").attr("data-match");
//     var min_t = $(this).attr("proti");
//     if (prop == min_t) {
//       var qut = $(this).attr("quantitiy");
//       var qut1 = $(this).attr("quantitiy1");
//       if (qut1 < 1) {
//         $(".sold-meta").addClass("sold_show");
//         $(".add-products").attr("disabled", true);
//         $(".mobile_add").attr("disabled", true);
//         $(".add-products").addClass("sold_btn");
//         $(".mobile_add").addClass("sold_btn");
//       } else if (qut < 1) {
//         $(".sold-meta").removeClass("sold_show");
//         $(".add-products").attr("disabled", false);
//         $(".mobile_add").attr("disabled", false);
//         $(".add-products").removeClass("sold_btn");
//         $(".mobile_add").removeClass("sold_btn");
//       }
//     }
//   });
// });

// $(".add-products").click(function () {
//   var sz = $(".var_text.price_active").text();
//   var name = $(".coll-meta.bundle_active").attr("data-match");
//   var vid = $('.var_text[proti="' + name + '"][size="' + sz + '"]').attr(
//     "var-id"
//   );
//   var fontname = $(".engraving--details.coll-details-part p#fontName")
//     .find(".text-co")
//     .text();
//   var name_q = $(".engraving--details.coll-details-part p#Name")
//     .find(".text-co")
//     .text();
//   var phone = $(".engraving--details.coll-details-part p#phone")
//     .find(".text-co")
//     .text();
//   var pro_id = $(this).attr("coll_nex");
//   var items = [];
//   items.push({
//     id: vid,
//     quantity: 1,
//     properties: { font: fontname, Name: name_q, PhoneNumber: phone },
//   });
//   if (
//     $(".last_div .full--width.engraving--added.mb-3").hasClass("add_products")
//   ) {
//     items.push({ id: pro_id, quantity: 1 });
//   } else {
//   }
//   console.log(vid);
//   $.ajax({
//     type: "POST",
//     url: "/cart/add.js",
//     data: { items: items },
//     dataType: "json",
//     success: function (response) {
//       console.log("success");
//       cart.getCart();
//     },
//     error: function () {
//       console.log("error");
//     },
//   });
// });

$(".hide_bb").click(function () {
    $(".opt-btn-new .full--width.engraving--added.mb-3").hide();
    $(".opt-btn-new .coll_btn .custom_btn").show();
});

// $(document).ready(function () {
//   var text = $(".var_text.price_active").text();
//   $('.var_text[size="' + text + '"]').each(function () {
//     var title = $(this).attr("proti");
//     var mat = $(".coll-meta.bundle_active").attr("data-match");
//     if (title == mat) {
//       var qut = $(this).attr("quantitiy");
//       var qut1 = $(this).attr("quantitiy1");
//       console.log(qut);
//       if (qut1 < 1) {
//         $(".sold-meta").addClass("sold_show");
//         $(".add-products").attr("disabled", true);
//         $(".add-products").addClass("sold_btn");
//         $(".mobile_add").attr("disabled", true);
//         $(".mobile_add").addClass("sold_btn");
//       } else if (qut < 1) {
//         $(".sold-meta").removeClass("sold_show");
//         $(".add-products").attr("disabled", false);
//         $(".mobile_add").attr("disabled", false);
//         $(".add-products").removeClass("sold_btn");
//         $(".mobile_add").removeClass("sold_btn");
//       }
//     }
//   });
// });

// $(".opt-btn-new .custom_btn").click(function () {
//   $(".opt-btn-new .engraving-slide-drawer").addClass("open_mb");
// });